import { fileUrl } from "@/lib/api";

// Static default lives in /public; admin-uploaded QR is an object-storage path.
export const qrSrc = (path) => (!path || path.startsWith("/") ? path || "/upi-qr.png" : fileUrl(path));
